import styled from 'styled-components'

const ServiceCardStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0.25rem;
  border: 2px solid rgba(255, 250, 250, 0.15);
  width: 25vw;
  ${'' /* min-height: 18vw; */}
  z-index: 1;
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0.45) 100%
  );
  transition: all 1s ease;
  aspect-ratio: 4/3;

  margin: 1rem;
  padding: 1.5rem;
  flex-shrink: 0;

  &:hover {
    border: 2px solid rgba(255, 250, 250, 0.5);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.25) 0%,
      rgba(0, 0, 0, 0.65) 100%
    );
    h4 {
      transition: all 1s ease;
      color: ${(props) => props.theme.primary};
    }
  }

  .just-start {
    width: 100%;
    display: flex;
    justify-content: start;
  }

  .ubuntu {
    font-family: 'Ubuntu', sans-serif;
  }

  img {
    margin-bottom: 0.5rem;
    background-color: rgb(0, 0, 0, 0.75);
    background:
      linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)) padding-box,
      linear-gradient(-205deg, #18879d, #184f9d) border-box;
    border-radius: 0.5rem;
    border: 2px solid transparent;
    padding: 0.85rem;
    color: ${(props) => props.theme.text};
    cursor: pointer;
    height: 4rem;
    aspect-ratio: 1/1;
  }
  @media (max-width: 968px) {
    width: 80%;
    aspect-ratio: 7/3;
    ${'' /* min-height: 60vw; */}
  }

  @media (max-width: 768px) {
    width: 92%;
    aspect-ratio: 7/4.5;
    ${'' /* min-height: 60vw; */}
  }

  @media (max-width: 361px) {
    width: 90%;
    aspect-ratio: 1/0.9;
  }
`

export default ServiceCardStyle
